module.exports = __webpack_public_path__ + "img/qcCode.40bc1655.jpg";